/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const ManageIcon: React.SFC = () => {
  return (
      <svg width="18" height="19" viewBox="0 0 18 19">
      <g fill="none" fillRule="evenodd">
      <path fill="#555A77" d="M8 6h2v3H8zM2 11V9h14v2z"/>
      <path stroke="#555A77" strokeWidth="2" d="M13 14h4v4h-4zM5 1h8v4H5zM1 14h4v4H1z"/>
      <path fill="#555A77" d="M14 9h2v4h-2zM2 9h2v4H2z"/>
      </g>
      </svg>
  )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Manage/Manage.tsx